module.exports = __webpack_public_path__ + "img/switch_img2_msg3.6ef3dd70.png";